<template>
	<button
		class="backButton"
		@click="goBack"
		@keydown.enter="goBack1"
		tabindex="0"
	>&larr;返回上一页</button>
</template>

<script>
	export  default {
		methods: {
			goBack() {
				this.$router.back();
			},
			goBack1(event) {
				event.preventDefault();
				this.$router.back();
			}
		}
	}
</script>

<style>
.backButton {
	justify-content: center;
	border: none;
	border-radius: 10%;
	cursor: pointer;
}
</style>